import React from 'react';
import Loadable from 'react-loadable';

import loadable from '@loadable/component';

const LoadingSpinner = loadable(() =>
  import('../../../components/loading_spinner/loading_spinner')
);

let PageComponent = false;
let ModernPageComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  PageComponent = require('./best_workplaces_page').default;
  // eslint-disable-next-line global-require
  ModernPageComponent = require('./best_workplaces_page_modern').default;
}

export function defaultBwiPage(store) {
  const routeConfig = {
    path: '/best-workplaces-for-innovators/:year(2019|2020|2021)',
    component() {
      if (PageComponent) {
        return <PageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: PageComponent ? PageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./best_workplaces_page').then(resp => {
        PageComponent = resp.default;
        routeConfig.loadData = PageComponent.loadData(store);

        return PageComponent;
      });
    },
    chunk: 'defaultBwiPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

export function modernBwiPage(store) {
  const routeConfig = {
    path: '/best-workplaces-for-innovators/:page(list)/:rank?',
    component() {
      if (ModernPageComponent) {
        return <ModernPageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: ModernPageComponent ? ModernPageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./best_workplaces_page_modern').then(resp => {
        ModernPageComponent = resp.default;
        routeConfig.loadData = ModernPageComponent.loadData(store);

        return ModernPageComponent;
      });
    },
    chunk: 'modernBwiPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
